interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | string)[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = buildPages(current, total);

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        <i className="ri-arrow-left-s-line text-lg" />
        上一页
      </button>

      {pages.map((page, i) =>
        typeof page === "number" ? (
          <button
            key={page}
            type="button"
            onClick={() => onChange(page)}
            className={`flex h-9 w-9 items-center justify-center rounded-md text-sm font-medium transition-colors ${
              page === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-700"
            }`}
          >
            {page}
          </button>
        ) : (
          <span key={`gap-${i}`} className="px-1 text-sm text-foreground-400">
            {page}
          </span>
        ),
      )}

      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700"
      >
        下一页
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </div>
  );
}